/**
 * Returns a method that wraps the original one with an async debounce
 * @param method The method that should be debounced
 * @param debounceMs The timeout in millisecs
 */
export const debounce = function (method) {
  let debounceMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  let timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      method(...args);
      clearTimeout(timeout);
      timeout = undefined;
    }, debounceMs);
  };
};
//# sourceMappingURL=debounce.js.map